module.exports = __webpack_public_path__ + "static/media/brand-library-demo.9b552615.gif";